import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestForwardCookieGet = {
    path: "/forward/cookie/:slug",
    method: RouteHttpVerb.GET
};
export { locationRestForwardCookieGet };
